import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { InlineInputGroup, InputNumber } from 'barnyard/components';


const InlineInputNumber = (props) => {
  const {
    label,
    description,
    ...other
  } = props;

  return (
    <InlineInputGroup
      label={label}
      description={description}
      InputComponent={InputNumber}
      {...other}
    />
  );
};

InlineInputNumber.propTypes = {
  label: PropTypes.string,
  description: PropTypes.string,
};

InlineInputNumber.defaultProps = {
};

export default memo(InlineInputNumber);
